{"name":"peachy-dev","accountHash":"535b45e","servicePatchUrl":"https://s3.eu-west-2.amazonaws.com/535b45e.peachydev.servicepatchstack.servicepatch"}